module.exports = __webpack_public_path__ + "static/media/shield.be6d08ca.svg";